@let ctrl = control();
<mat-form-field>
  <mat-label>{{ label() }}</mat-label>
  <input matInput type="number" appNoScroll [formControl]="ctrl" />
  @if (ctrl.hasError('required')) {
    <mat-error>{{ label() }} er påkrævet</mat-error>
  }
  @if (ctrl.hasError('pattern')) {
    <mat-error>{{ label() }} skal være et tal på 2 til 12 cifre</mat-error>
  }
  @if (ctrl.pending) {
    <ok-form-field-loading></ok-form-field-loading>
  }
</mat-form-field>
@if (ctrl.hasError('agreementDoesNotExist')) {
  <ok-feedback-fail>
    <b>Vi kunne ikke finde en aftale ud fra det angivne {{ label() }}</b>
  </ok-feedback-fail>
}
@if (ctrl.valid && ctrl.value && agreementDetails(); as details) {
  <ok-feedback-success>
    <div>
      Aftalen <b>{{ details.account_name }}</b> blev fundet.<br />
      Kontonr: <b>{{ details.account_number ?? '-' }}</b
      ><br />
      Kontoformål: <b>{{ details.account_purpose }}</b>
    </div>
  </ok-feedback-success>
}
